import type { Asset } from '@/types';
import ScrollableList from '@/ui/components/scrollable-list';
import TokenItem from './token-item.js';

export interface TokenListProps {
  tokens: Asset[];
}

function TokenList({ tokens }: TokenListProps) {
  return (
    <ScrollableList
      items={tokens}
      renderItem={(token) => <TokenItem token={token} />}
      getItemKey={(token) => token.name}
      className="pb-4"
      forceBorder
    />
  );
}

export default TokenList;
